import { TableCell, Typography } from "@mui/material";

export function OrganizationsTableRows({ organization }) {

  return (
    <>
      <TableCell align='left'>
        <Typography variant='body_semi_bold'>{organization.name}</Typography>
      </TableCell>
      <TableCell align='left'>
        <Typography variant='body_semi_bold'>{organization.claim}</Typography>
      </TableCell>
      <TableCell align='left'>
        <Typography variant='body_semi_bold'>{organization.logoUrl ? "Si" : "No"}</Typography>
      </TableCell>
      <TableCell align='left'>
        <Typography variant='body_semi_bold'>{organization.merchant}</Typography>
      </TableCell>
      <TableCell align='left'>
        <Typography variant='body_semi_bold'>{organization.merchantLogoUrl ? "Si" : "No"}</Typography>
      </TableCell>
    </>
  );
}

